import { render, staticRenderFns } from "./inspecao.vue?vue&type=template&id=0bebb6d6&scoped=true&"
import script from "./inspecao.vue?vue&type=script&lang=js&"
export * from "./inspecao.vue?vue&type=script&lang=js&"
import style0 from "./inspecao.vue?vue&type=style&index=0&id=0bebb6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bebb6d6",
  null
  
)

export default component.exports